module.exports = __webpack_public_path__ + "static/Patrick_O'Hern_Resume-400d06cec04417f6abde40c2567e9f34.pdf";